import { Formik, FormikProps } from "formik";
import React, { FC, memo } from "react";

import { IEditableSectionRenderProps, useEditableSubmit } from "@/components/EditableSection";
import { IConsultantProfile } from "@/data/consultant-profiles";
import { IConsultantProfileRole } from "@/data/roles";
import { FormikForm } from "@/formikComponents";
import { profileRoleSectionValidationSchema } from "@/views/components/ConsultantProfile/SuggestedData";
import { FormikConsultantProfileRoleSection } from "@/views/ConsultantProfiles/Detail/GeneralSection/RoleSectionEdit";

import { profilePartialUpdaterBuilder } from "../profilePartialUpdaterBuilder";
import { IProfileFormikProps } from "../types";

export interface IRolesFormSectionValues {
  roles: IConsultantProfileRole[];
}

interface IRoleFormSectionProps {
  form: FormikProps<IRolesFormSectionValues>;
}

export const ROLE_MESSENGER_CONTEXT = "profile-role-form";

interface IRoleFormProps extends IRoleFormSectionProps, IEditableSectionRenderProps {
  source: IConsultantProfile;
}

export const RoleForm: FC<IRoleFormProps> = memo(({ form, editableProps }) => {
  useEditableSubmit(form, editableProps);

  return (
    <FormikForm>
      <FormikConsultantProfileRoleSection name="role" value={form.values.roles} form={form} />
    </FormikForm>
  );
});

interface IRoleFormikProps extends IProfileFormikProps<IRolesFormSectionValues>, IRoleFormProps {}

export const RoleFormik: FC<IRoleFormikProps> = memo(({ initialValues, validationSchema, onSubmit, ...rest }) => (
  <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit}>
    {(form: FormikProps<IRolesFormSectionValues>) => <RoleForm {...rest} form={form} />}
  </Formik>
));

export const ConsultantProfileRoleEdit = profilePartialUpdaterBuilder(RoleFormik, {
  validationSchema: profileRoleSectionValidationSchema,
  messengerContext: ROLE_MESSENGER_CONTEXT,
});
